export enum CalculatorKeys {
  INCOME = 'venituri',
  COSTS = 'cheltuieli',
  OTHER = 'other',
}

export type CalculatorStepItemType = {
  id: string;
  name: string;
  label: string;
};

export type CalculatorStepType = {
  id: string;
  name: CalculatorKeys;
  label: string;
  items: CalculatorStepItemType[];
};

export type CalculatorStateItemType = {
  [key: string]: {
    value: string;
    active: boolean;
    status: 'success' | 'error' | null;
  };
};

export type CalculatorStateType = Record<
  CalculatorKeys,
  {
    [key: string]: {
      value: string;
      active: boolean;
      status: 'success' | 'error' | null;
    };
  }
>;

export type CalculatorHandleChangeType = (prop: {
  name: string;
  pName: CalculatorKeys;
  value: string | boolean;
}) => void;

export type FileResponseType = { blob: Blob; contentType?: string };
